import request from '@/utils/request'

/**
 * 查询家政服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServ(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.queryHousekeepingServ',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增家政服务
 * @param {Object} data 新增数据
 * @returns {Promise} Promise对象
 */
export function saveHousekeepingServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.saveHousekeepingServ',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if(res.code === 0){
        resolve(res)
      }else{
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新家政服务
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateHousekeepingServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.updateHousekeepingServ',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if(res.code === 0){
        resolve(res)
      }else{
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteHousekeepingServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.deleteHousekeepingServ',
      method: 'post',
      data:  data
    }).then(response => {
      const res = response.data
      if(res.code === 0){
        resolve(res)
      }else{
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}